import { render, staticRenderFns } from "./GraficaDinero.vue?vue&type=template&id=22855e89&scoped=true"
import script from "./GraficaDinero.vue?vue&type=script&lang=js"
export * from "./GraficaDinero.vue?vue&type=script&lang=js"
import style0 from "./GraficaDinero.vue?vue&type=style&index=0&id=22855e89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22855e89",
  null
  
)

export default component.exports